import ValidaTexto from '../../validadores/ValidaTexto';

export default class ValidaEnvolvidos {
    
    static valida(_envolvidos) {

        return new Promise((resolve,reject) => {
            try {
                const envolvidos = validarEnvolvidos(_envolvidos)
                resolve(envolvidos)
            } 
            catch (msgErro) {
                reject(msgErro)
            }
        })
    }
}

const validarEnvolvidos = envolvidos => {
    let listaEnvolvidos = []
    if (!envolvidos) {
        return envolvidos
    }

    if (envolvidos.length === 0) {
        return envolvidos
    }

    let envolvido = null;
    for (let i=0; i<envolvidos.length; i++) {
        envolvido = envolvidos[i];
        validaTitulo(envolvido,i)
        if (envolvido.nome || envolvido.cargo || envolvido.areaDepartamento) {
            ValidaTexto.valida(envolvido.nome, `NOME_${i+1}`, true, 128);
            ValidaTexto.valida(envolvido.cargo, `CARGO_OU_FUNÇÃO_${i+1}`, true, 256);
            ValidaTexto.valida(envolvido.areaDepartamento, `ÓRGÃO_SECRETARIA_OU_SETOR_${i+1}`, true, 256);
            listaEnvolvidos.push(envolvido)
        }
    }

    return listaEnvolvidos;
}

const validaTitulo = (envolvido,i) => {
    const todosOsCampos = (envolvido.nome + envolvido.cargo + envolvido.areaDepartamento).trim()
    const nomeCampo = `Envolvido_${i+1}`
    try {
        ValidaTexto.valida(todosOsCampos, nomeCampo, false, 1024);
    } catch (msgErro) {
        throw obterMsgErro(
            `Pelo menos um dos campos de '${nomeCampo}' deve estar preenchido!`
        );
    }
}

const obterMsgErro = msgErro => {
    return ({ OK:false, status:400, tipo:'problema', texto:msgErro });
}